import { AuthenticatedLayout } from "features/common/components/AuthendicatedLayout";
import { ReportPreview } from "features/report/components/ReportPreview";

export const ExternalReconciliation = () => {
  return (
    <AuthenticatedLayout>
      <ReportPreview action="RECONCILIATION" />
    </AuthenticatedLayout>
  );
};
